// extracted by mini-css-extract-plugin
export default {"root":"DetailBox_root__HdQOr","detail":"DetailBox_detail__reJbe"};